import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/i18n";
import { ThemeProvider } from "@/context/ThemeContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";
import ScrollToTop from "@/components/ScrollToTop";
import HomePage from "@/pages/HomePage";
import CapacitacionesPage from "@/pages/CapacitacionesPage";
import ConferenciasPage from "@/pages/ConferenciasPage";
import ConsultoriasPage from "@/pages/ConsultoriasPage";
import DesarrolloPage from "@/pages/DesarrolloPage";
import ContactoPage from "@/pages/ContactoPage";

function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <ScrollToTop />
        <div className="min-h-screen flex flex-col">
          <Navbar />
          <div className="flex-1">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/capacitaciones" element={<CapacitacionesPage />} />
              <Route path="/conferencias" element={<ConferenciasPage />} />
              <Route path="/consultorias" element={<ConsultoriasPage />} />
              <Route path="/desarrollo" element={<DesarrolloPage />} />
              <Route path="/contacto" element={<ContactoPage />} />
              <Route path="*" element={<HomePage />} />
            </Routes>
          </div>
          <Footer />
          <WhatsAppButton />
        </div>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
